// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1a2jX","content":"styles_content__23lQ5","header":"styles_header__13iPK","options":"styles_options__1KW3y","option":"styles_option__29qet"};